/**
 * SNAP TO; Snap the final position of drag (Visual)
 * SNAP_TIME_TO: Snap the final start time of a finished drag to the nearest time (Value)
 */
export const SNAPS = {
    SNAP_TO: 5,
    SNAP_TIME_TO: 5,
};
